import React, { useId } from "react";
import GenericInput from "@ui-components/Input/GenericInput";
import { FormField, TextArea } from "./FormField";
import {
  DESCRIPTION_HINT,
  TITLE_HINT,
  descriptionError,
  titleError,
} from "./fieldRules";

interface SummaryFieldsProps {
  title: string;
  description: string;
  onTitleChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  titlePlaceholder?: string;
  descriptionPlaceholder?: string;
}

/** Title and description, which every request type asks for. */
export function SummaryFields({
  title,
  description,
  onTitleChange,
  onDescriptionChange,
  titlePlaceholder = "A short summary",
  descriptionPlaceholder = "Tell us the details",
}: SummaryFieldsProps) {
  const descriptionId = useId();
  const titleProblem = titleError(title);
  const descriptionProblem = descriptionError(description);

  return (
    <>
      <FormField label="Title" required hint={TITLE_HINT} error={titleProblem}>
        <GenericInput
          placeholder={titlePlaceholder}
          value={title}
          onChange={onTitleChange}
          fullWidth
        />
      </FormField>
      <FormField
        label="Description"
        required
        htmlFor={descriptionId}
        hint={DESCRIPTION_HINT}
        error={descriptionProblem}
      >
        <TextArea
          id={descriptionId}
          value={description}
          onChange={onDescriptionChange}
          placeholder={descriptionPlaceholder}
          invalid={Boolean(descriptionProblem)}
        />
      </FormField>
    </>
  );
}

export default SummaryFields;
